#import "../fragments/user-video-integrations-fragment.graphql"

query GetUserVideoIntegrations {
    loggedInUser {
        ...UserVideoIntegrationsFragment
    }
}
